export enum AppRoutes {
  PristupOdepren = 'pristup-odepren',
  Nenalezeno = 'nenalezeno',
  ChybaServeru = 'chyba-serveru',
  Uzivatele = 'uzivatele',
  Certifikaty = 'certifikaty',
  CertifikatyOvereni = 'certifikaty-overeni',
  Opravneni = 'opravneni',
  OvereniOpravneniOld = 'overeni-opravneni-old',
  OvereniOpravneni = 'overeni-opravneni',
  OvereniOpravneni_Zastupujici = 'zastupujici',
  OvereniOpravneni_Zastupovany = 'zastupovany',
  OvereniOpravneni_KodOkz = 'kod-okz',
  Sablony = 'sablony',
  Sablony_Skupiny = 'sablony-skupiny',
  Reklamace = 'reklamace',
  Reklamace_ImplicitnichOpravneni = 'reklamace-implicitnich-opravneni',
  Reklamace_KontrolaReklamaciImplicitnichOpravneni = 'kontrola-reklamaci-implicitnich-opravneni',
  MujDetail = 'muj-detail',
  Zadosti = 'zadosti',
  MojeZadosti = 'moje-zadosti',
  DelegovaneZadosti = 'delegovane-zadosti',
  Sprava = 'sprava',
  SeznamSablon = 'seznam-sablon',
  KatalogSkupinSablon = 'katalog-skupin-sablon',
  Dms = 'dms',
  Statistiky = 'statistiky',
  Statistiky_PocetOpravneniKZastupovani = 'pocet-opravneni-k-zastupovani',
  Statistiky_ZmenyOpravneniKZastupovani = 'zmeny-opravneni-k-zastupovani',
  Statistiky_OpravneniKZastupovaniDleSablon = 'opravneni-k-zastupovani-dle-sablon', //Statistiky vytvořených oprávnění k zastupování dle šablon
  Statistiky_PoctuCertifikatu = 'poctu-certifikatu', //Statistiky vytvořených oprávnění k zastupování dle šablon
  Archiv = 'archiv',
  Ciselniky = 'ciselniky',
  ObjektyOmezeni = 'objekty-omezeni',
  Role = 'role',
  SpecifickaOmezeni = 'specificka-omezeni',
}

export enum AppRoutesParams {
  Home = 'home',

  AdminContext = 'admin',
  ContextId = 'contextId',
  WebsiteId = 'websiteId',
  CategoryId = 'categoryId',
  CategoryGroupId = 'categoryGroupId',
  DmsFolderId = 'dmsFolderId',
  DmsFileId = 'dmsFileId',
  DmsContextId = 'dmsContextId',
  PageId = 'pageId',
  FaqId = 'faqId',
  ContentType = 'contentTypeInUrl',
  NewWebContentSubType = 'newWebContentSubType',
  EditWebContentSubType = 'editWebContentSubType',
  AddDocumentInWebContentId = 'addDocumentInWebContent',
  CopyCasovaRada = 'copyCasovaRada',
}

// helper context id if there are no contexts
export const NO_CONTEXTS_ID = -1;
export const DMS_API_URL = '/api/dms';
// export const BE_API_URL = '/api/redakcni-system';
export const BE_API_URL = '/api';
export const FAQ_API_URL = '/api/faq';
export const PRODUCTS_API_URL = '/api/katalog-produktu';
export const UDV_DATASTAT_DATA_URL = '/datastat/api/dotaz/data/vybery';
export const UDV_DATASTAT_CATALOG_URL = '/datastat/api/katalog/vybery';

export const APP_NAVBAR_FIRST_ITEM_ID = 'pages-menu-item';
